module.exports = __webpack_public_path__ + "img/inits.f5df9aad.svg";